/**
 * DEPRECATED - Legacy top-navigation component.
 *
 * The app now uses a left sidebar rendered globally by <AppShell> (see
 * components/layout/AppSidebar.js). This file is kept as a no-op shim for
 * backward compatibility with pages that still import MainNavigation
 * directly; it renders nothing and should be removed over time.
 */
const MainNavigation = () => null;

export default MainNavigation;
